import { alias, AliasedConstructor } from '../../rest/decorators/alias'
import { RestQuery } from '../../rest/utilities/rest-query'
import { SerialisationConfig } from '../../rest/utilities/serialisable'
import { BaseEngineer } from './base-engineer'
import { Category } from './category'
import { ClockIn } from './clock-in'
import { EngineerWorkingDay } from './engineer-working-day'

export class Engineer extends BaseEngineer {
  public static override serialisationConfig: SerialisationConfig =
    new SerialisationConfig(() => new Engineer(), {
      category: new SerialisationConfig(() => new Category()),
      workingDays: new SerialisationConfig(() => new EngineerWorkingDay()),
      lastClockIn: new SerialisationConfig(() => new ClockIn()),
    })

  @alias('latest_clock_in')
  lastClockIn!: ClockIn | null

  constructor() {
    super((Engineer as unknown as AliasedConstructor)._alias)
  }

  static override create<Data>(attrs: Data) {
    return new Engineer().update(attrs, Engineer.serialisationConfig)
  }
}

interface Filters {
  keywords?: string
  has_left?: boolean
  is_locked?: boolean
  no_reporting?: boolean
  clocked?: boolean
  categorised?: boolean
  archive?: string
}
type Ordering = 'name' | '-name' | 'email' | '-email' | 'category' | '-category'
type Includes = 'category' | 'latestClockIn' | 'workingDays'

export class EngineerQuery extends RestQuery<Filters, Ordering, Includes> {}
